import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import routesConfig from '../routes'
import showMessage from './global/showMessage'

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(showMessage);

const generateRoutes = x => {
    let routes = x.routes.map(item => {
        let obj = {
            path: item.path,
            name: item.name,
            component: function (resolve) {
                require(['.' + item.component], resolve)
            }
        };
        if (item.routes) {
            obj.children = generateRoutes(item)
        }
        if (item.alias) {
            obj.alias = item.alias
        }
        if (item.meta) {
            obj.meta = Object.assign({}, item.meta)
        }
        return obj
    });
    return routes
};

let routes = generateRoutes(routesConfig);

console.log(routes);

const router = new VueRouter({
    routes: routes,
    saveScrollPosition: true,
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

/* eslint-disable no-new */
document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        el: '#app',
        render: h => h(App),
        router
    })
});



// WEBPACK FOOTER //
// ./src/main.js